import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddPurchaseOrder = () => {
    const [formData, setFormData] = useState({
        pack_unit: '',
        pack_qty: '',
        unit: '',
        quantity: '',
        free_quantity: '',
        rate: '',
        amount: '',
        discount: '',
        tax_code: '',
        tax_rate: '',
        taxable: '',
        tax_amount: '',
        cess_rate: '',
        cess_amount: '',
        mrp: '',
        net_rate: '',
        remarks: '',
        item_barcode: '',
        req_vno: '',
        req_ref_no: '',
        req_ref_date: '',
        req_vdate: '',
        item_balance: '',
        barcode: '',
        line_level_barcode: '',
        lgst: '',
        cgst: '',
        sgst: '',
        hsn_code: '',
        brand: '',
    });

    const navigate = useNavigate();

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        fetch(`${BASE_URL}purcheshorder`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert('Purchase Order added successfully!');
                    navigate('/PurchaseOrderList'); // Redirect to purchase order list
                } else {
                    alert('Error adding purchase order. Please try again.');
                }
            })
            .catch((error) => console.error('Error:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Purchase Order</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Purchase Order Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Purchase Order Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {Object.keys(formData).map((field) => (
                                        <div className="mb-3" key={field}>
                                            <label
                                                htmlFor={field}
                                                className="form-label"
                                            >
                                                {field.replace(/_/g, ' ').toUpperCase()}
                                            </label>
                                            <input
                                                type={field.includes('date') ? 'date' : 'text'}
                                                id={field}
                                                name={field}
                                                className="form-control"
                                                value={formData[field]}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    ))}
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Add Purchase Order
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Add Purchase Order Form */}
        </div>
    );
};

export default AddPurchaseOrder;
